<template>
  <div>
    <header-component></header-component>

    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform:capitalize;">Vendors List</h3>
          <div class="col-lg-12 col-5 text-right">
            <base-button size="sm" type="primary" @click="createVendor"
              >Add New</base-button
            >
          </div>
        </div>
        <el-table
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
          :data="vendorList"
        >
          <el-table-column label="Name">
            <template slot-scope="scope"
              >{{ scope.row.firstName }} {{ scope.row.lastName }}</template
            >
          </el-table-column>

          <el-table-column label="Gender" prop="gender"></el-table-column>
          <el-table-column label="Email" prop="email"></el-table-column>
          <el-table-column label="Phone" prop="phone"></el-table-column>
          <el-table-column
            label="Type"
            prop="serviceCategory.label"
          ></el-table-column>
          <el-table-column label="Active Status">
            <template slot-scope="scope">
              <badge v-if="scope.row.isActive === false" type="danger"
                >Inactive</badge
              >
              <badge v-else type="success">Active</badge>
            </template>
          </el-table-column>

          <el-table-column min-width="70px">
            <template slot-scope="scope">
              <el-dropdown
                slot="dropdown"
                @command="command => handleAction(scope.row, command)"
              >
                <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu
                  class="dropdown-menu dropdown-menu-arrow show"
                  slot="dropdown"
                >
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                  <el-dropdown-item command="changePassword"
                    >Change Password</el-dropdown-item
                  >
                  <el-dropdown-item command="showPoints"
                    >Show Points</el-dropdown-item
                  >
                  <el-dropdown-item command="showLabors">
                    Show All Labors
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog title="Add Vendor" :visible.sync="addVendor">
        <add-vendor @close="addVendor = false"></add-vendor>
      </el-dialog>
      <el-dialog
        title="Change Password"
        :visible.sync="changePasswordModal"
        width="30%"
      >
        <change-password @close="changePasswordModal = false"></change-password>
      </el-dialog>
      <el-dialog
        v-if="selectedVendor"
        :title="
          'Show Monthwise Points of ' +
            selectedVendor.firstName +
            ' ' +
            selectedVendor.lastName
        "
        :visible.sync="showPoints"
      >
        <div>
          <el-table
            class="table-responsive table-flush"
            header-row-class-name="thead-light"
            :data="pointList"
          >
            <el-table-column label="Month">
              <template slot-scope="scope">{{ scope.row.title }}</template>
            </el-table-column>
            <el-table-column label="Total Service Requests">
              <template slot-scope="scope">{{ scope.row.count }}</template>
            </el-table-column>
            <el-table-column label="Average Points">
              <template slot-scope="scope">{{ scope.row.points }}</template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import { mapGetters, mapActions, mapMutations } from "vuex";
import AddVendor from "./AddVendor";
import headerComponent from "../Components/HeaderComponent";
import changePassword from "./changePassword.vue";
export default {
  data: () => {
    return {
      addVendor: false,
      changePasswordModal: false,
      showPoints: false,
      selectedMonth: null,
      points: 0,
      pointList: [],
      selectedVendor: null
    };
  },

  computed: {
    ...mapGetters({
      vendor: "vendor/getVendor",
      vendorList: "vendor/getVendorList"
    })
  },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    "add-vendor": AddVendor,
    "header-component": headerComponent,
    "change-password": changePassword
  },
  mounted() {
    this.getVendorList();
  },

  methods: {
    ...mapActions({
      getVendorList: "vendor/getVendorList",
      fetchVendor: "vendor/fetchVendor",
      getVendorMonthwisePoints: "vendor/getVendorMonthwisePoints"
    }),
    ...mapMutations({
      setVendor: "vendor/setVendor",
      resetVendor: "vendor/resetVendor"
    }),
    handleAction(vendor, command) {
      if (command === "edit") {
        this.fetchVendor(vendor.vendorId).then(res => {
          this.$router.push(`/vendors/${vendor.vendorId}/edit`);
          this.setVendor(res);
        });
      } else if (command === "changePassword") {
        this.setVendor(vendor);
        this.changePasswordModal = true;
      } else if (command === "showPoints") {
        this.selectedVendor = vendor;
        this.getVendorPoints(vendor.vendorId);
      } else if (command === "showLabors") {
        this.getVendorPoints(vendor.vendorId);
        this.$router.push("/vendors/" + vendor.vendorId + "/labors");
      }
    },

    async getVendorPoints(vendorId) {
      this.getVendorMonthwisePoints({
        vendorId
      }).then(res => {
        this.pointList = res;
        this.showPoints = true;
      });
    },

    createVendor() {
      this.resetVendor();
      this.$router.push("/vendors/add");
    }
  }
};
</script>
